/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    a: "a",
    div: "div",
    p: "p",
    h2: "h2"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.h1, {
    id: "selecting-components-for-jacdac-devices",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#selecting-components-for-jacdac-devices",
    "aria-label": "selecting components for jacdac devices permalink",
    className: "anchor before"
  }, React.createElement(_components.div, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Selecting Components for Jacdac Devices"), "\n", React.createElement(_components.p, null, "This page presents some information about part selection for some of the key components of many Jacdac devices. For some components we provide ", React.createElement(_components.a, {
    href: "https://github.com/microsoft/jacdac-ddk/tree/main/electronics/generic/suggested-components",
    target: "_blank",
    rel: "nofollow noopener noreferrer"
  }, "specific part numbers"), "."), "\n", React.createElement(_components.h2, {
    id: "microcontrollers",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#microcontrollers",
    "aria-label": "microcontrollers permalink",
    className: "anchor before"
  }, React.createElement(_components.div, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Microcontrollers"), "\n", React.createElement(_components.p, null, "The cheapest prototype Jacdac module implementations were based on ", React.createElement(_components.a, {
    href: "http://www.padauk.com.tw/en/product/",
    target: "_blank",
    rel: "nofollow noopener noreferrer"
  }, "PADAUK microcontrollers"), ", and more specifically the PMS150C-U6 and PFS122-S08. The ", React.createElement(_components.a, {
    href: "http://www.padauk.com.tw/en/product/show.aspx?num=17&kind=41",
    target: "_blank",
    rel: "nofollow noopener noreferrer"
  }, "PMS150C"), " is the cheapest but is one-time programmable and doesn't lend itself to in-circuit programming so must be programmed before being fitted. It is also very resource-constrained. The ", React.createElement(_components.a, {
    href: "http://www.padauk.com.tw/en/product/show.aspx?num=141&kind=42",
    target: "_blank",
    rel: "nofollow noopener noreferrer"
  }, "PFS122"), " has more RAM and program memory, supports analog input, and is re-programmable with a relatively low voltage that's compatible with in-circuit programming."), "\n", React.createElement(_components.p, null, "For more sophisticated Jacdac modules, for example when more memory or particular peripherals are needed - such as I2C or SPI - the STM32G030 processors work well. We use the ", React.createElement(_components.a, {
    href: "https://www.st.com/en/microcontrollers-microprocessors/stm32g030f6.html",
    target: "_blank",
    rel: "nofollow noopener noreferrer"
  }, "STM32G030F6P6"), " TSSOP-20 variant in a lot of our designs."), "\n", React.createElement(_components.p, null, "Other microcontrollers should work fine too of course."), "\n", React.createElement(_components.h2, {
    id: "schottky-diodes",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#schottky-diodes",
    "aria-label": "schottky diodes permalink",
    className: "anchor before"
  }, React.createElement(_components.div, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Schottky diodes"), "\n", React.createElement(_components.p, null, "The obvious Schottky diode choice for clamping the JD_DATA line is a dual, series-connected BAT54S. There are many variants of this."), "\n", React.createElement(_components.p, null, "For designs that provide power delivery and/or have different options for power consumption, a higher-current Schottky diode with a low forward voltage drop is required."), "\n", React.createElement(_components.h2, {
    id: "esd-diodes",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#esd-diodes",
    "aria-label": "esd diodes permalink",
    className: "anchor before"
  }, React.createElement(_components.div, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "ESD diodes"), "\n", React.createElement(_components.p, null, "ESD diodes are recommended for Jacdac bus production for commercial module designs, since these signals will likely be exposed to ESD events. We also recommend the use of ESD protection for other electrical interfaces such as USB."), "\n", React.createElement(_components.p, null, "ESD diodes for JD_DATA protection should be ultra-low capacitance types, ideally less than 1pF but certainly no more than 4pF, in order to minimize load on the bus."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
